import * as THREE from "three";
import {
  HEMISPHERE_LIGHT_SKY_COLOR_DEFAULT,
  HEMISPHERE_LIGHT_GROUND_DEFAULT,
  HEMISPHERE_LIGHT_INTENSITY_DEFAULT,
  HEMISPHERE_LIGHT_POSITION_X_DEFAULT,
  HEMISPHERE_LIGHT_POSITION_Y_DEFAULT,
  HEMISPHERE_LIGHT_POSITION_Z_DEFAULT,
  HEMISPHERE_LIGHT_IS_VISIBLE_DEFAULT,
} from "../config";

export const hemisphereLightFactory = () => {
  const hemisphereLight = new THREE.HemisphereLight(
    HEMISPHERE_LIGHT_SKY_COLOR_DEFAULT,
    HEMISPHERE_LIGHT_GROUND_DEFAULT,
    HEMISPHERE_LIGHT_INTENSITY_DEFAULT
  );
  hemisphereLight.position.set(
    HEMISPHERE_LIGHT_POSITION_X_DEFAULT,
    HEMISPHERE_LIGHT_POSITION_Y_DEFAULT,
    HEMISPHERE_LIGHT_POSITION_Z_DEFAULT
  );
  hemisphereLight.visible = HEMISPHERE_LIGHT_IS_VISIBLE_DEFAULT;

  return hemisphereLight;
};
